module.exports = __webpack_public_path__ + "img/prison_radio.b1ce5ef8.png";